import SurgicalOrder from 'presentation/contexts/surgical-order/surgical-order-context'

export default function makeSurgicalOrderStore() {
  return new SurgicalOrder()
}
